// Copyright 2018 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SpinnerSk", {
    enumerable: true,
    get: function() {
        return SpinnerSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let SpinnerSk = class SpinnerSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    constructor(...args){
        super(...args);
        this.active = false;
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean,
        reflect: true
    }),
    _ts_metadata("design:type", Boolean)
], SpinnerSk.prototype, "active", void 0);
SpinnerSk = _ts_decorate([
    (0, _decorators.customElement)('spinner-sk')
], SpinnerSk);
